import React from 'react';
import Path from '../../components/reuseable/Path';

const ShortlistedResumes = () => {
  return (
    <div>
      <Path from="dashboard" to="Shortlisted Resumes" />
    </div>
  );
};

export default ShortlistedResumes;
